import { pcFilterInterface } from '@/types/types'
import type { pcFilterFieldsInterface } from '@/types/types'

export class PcFilterModel implements pcFilterInterface {
  filterPc: pcFilterFieldsInterface;

  constructor() {
    this.filterPc = {
      codpontocaptura: undefined,
      nompontocaptura: "",
      ufredeautoatndto: "",
      nomcidredeautoatndto: "",
      nomsegmmerclocalptoatndto: "",
      nomsubredeautoatndto: [],
      codsubredeautoatndto: undefined,
      nomtpmaqautoatndto: ""
    }
  }
}
